// File: src/layouts/Sidebar.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDirection } from '../hooks/useDirection';
import { useAuth } from '../hooks/useAuth';
import { UserRoleEnum } from '../types';
import SidebarLink from './SidebarLink';
import {
    HomeIcon,
    ChatBubbleLeftRightIcon,
    CalendarDaysIcon,
    SparklesIcon,
    CurrencyDollarIcon // NEW: Import CurrencyDollarIcon
} from '@heroicons/react/24/outline';

const Sidebar: React.FC = () => {
    const { t } = useTranslation('common');
    const { isRTL } = useDirection();
    const { user } = useAuth();

    const getAppointmentLink = () => {
        // MODIFIED: Coaches now land on the Availability page first.
        if (user?.role_name === UserRoleEnum.Coach) {
            return '/app/coach/availability';
        }
        return '/app/client/appointments-hub';
    };

    const getHomeLink = () => {
        if (user?.role_name === UserRoleEnum.Coach) {
            return '/app/coach-dashboard';
        }
        return '/app';
    }

    // NEW: Get Invoicing link based on role
    const getInvoicingLink = () => {
      if (user?.role_name === UserRoleEnum.Coach) {
        return '/app/coach/invoices';
      }
      return '/app/client/invoices';
    };

    return (
        <aside className={`w-40 bg-white p-3 flex flex-col items-center space-y-4 ${isRTL ? 'border-l border-neutral-light' : 'border-r border-neutral-light'}`}>
            <SidebarLink to={getHomeLink()} icon={<HomeIcon className="h-9 w-9" />} label={t('navigation.home')} />
            <SidebarLink to={getAppointmentLink()} icon={<CalendarDaysIcon className="h-9 w-9" />} label={t('navigation.appointments')} />
            
            <SidebarLink to="/app/messages" icon={<ChatBubbleLeftRightIcon className="h-9 w-9" />} label={t('navigation.messages')} />

            {/* NEW: Invoicing Link */}
            {(user?.role_name === UserRoleEnum.Coach || user?.role_name === UserRoleEnum.Client) && (
              <SidebarLink to={getInvoicingLink()} icon={<CurrencyDollarIcon className="h-9 w-9" />} label={t('navigation.invoices')} />
            )}

            <SidebarLink to="/app/ai" icon={<SparklesIcon className="h-9 w-9 text-red-500" />} label={t('navigation.ai_assistant')} />
        </aside>
    );
};

export default Sidebar;